var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaskGroup5930(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3285",
    "data-name": "Rectangle 3285",
    width: 28,
    height: 28,
    transform: "translate(325 37)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5930",
    "data-name": "Mask Group 5930",
    transform: "translate(-325 -37)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g971",
    transform: "translate(328 41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7597",
    "data-name": "Group 7597",
    transform: "translate(1 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path981",
    d: "M0-304.666a10,10,0,0,0,10,10,10,10,0,0,0,10-10,10,10,0,0,0-10-10A10,10,0,0,0,0-304.666Z",
    transform: "translate(0 314.666)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g983",
    transform: "translate(6.897 3.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path985",
    d: "M-196.548-98.274a3.059,3.059,0,0,1-3.059,3.059,3.059,3.059,0,0,1-3.059-3.059,3.059,3.059,0,0,1,3.059-3.059A3.059,3.059,0,0,1-196.548-98.274Z",
    transform: "translate(202.666 101.333)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g987",
    transform: "translate(5.619 13.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path989",
    d: "M-287.164-60.775a5.148,5.148,0,0,0-3.992-1.892h-.955a5.148,5.148,0,0,0-3.992,1.892",
    transform: "translate(296.103 62.667)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup5930);
export default __webpack_public_path__ + "static/media/Mask Group 5930.146fe138663e27a22d16f47c9fa3fa6c.svg";
export { ForwardRef as ReactComponent };